/***************/
/**  IMPORTS  **/
/***************/
import { useEffect, useState, useRef } from "react";
import Cookies from "universal-cookie";

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { 
    LocationBarContainer, 
    AvailableBar1,
    NotAvailableBar1, 
    LocCol,
    LocColBuildingNum, 
    LocColAvailability,
    LocColPlus,
    LocColName,
    LocRow,
    Shadow,
    OutsideShadow,
    TemporarilyClosedBar
} from "../../styles/LocationBarStyles";
import { useAuth } from '../../utils/AuthContext';
import Modal from "../Modal";
import circle_plus from "../../assets/circle_plus.svg";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../../amplifyconfiguration.json';

/**
 * This component is responsible for creating a Location Bar
 * @param { JSON Object }   data                All of the location data
 * @param { Function }      setSearchClicked    Sets whether the Search button is clicked
 * @param { Boolean }       searchClicked       Determines whether the search button is clicked
 * @param { Function }      setModalOpen        Sets whether the modal is open
 * @param { Boolean }       modalOpen        Sets whether the modal is open
 * @param { Function }      setHighlightClicked Sets whether the dark background is clicked when the location is highlighted
 * @param { Boolean }       highlightClicked    Determines whether the dark background is clicked when the location is highlighted
 * @param { Function }      setUpClicked        Sets whether the scroll up button is clicked
 * @param { Boolean }       upClicked           Determines whether the scroll up button is clicked
 * @param { Function }      setModalChange      Sets when the location details have been manually changed
 * @param { Boolean }       modalChange         Determines whether the location details have been manually changed
 * @returns A Location Bar
 */
const LocationBar = ({data, setSearchClicked, searchClicked, setModalOpen, modalOpen, highlightClicked, setHighlightClicked, upClicked, setUpClicked, modalChange, setModalChange, onUpdate, flipped }) => {

    const [message, setMessage] = useState("");
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [theID, setTheID] = useState(null);
    const [accountData, setAccountData] = useState(null);
    // const [comment, setComment] = useState(false);
    const { userData } = useAuth() || {};
    const ref = useRef(null);

    Amplify.configure(amplifyconfig);

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const email = localStorage.getItem("EMAIL");
    
    /**
     * This function is responsible for making sure each location bar outputs the correct location data.
     * It filters the MongoDB data and makes sure each Location Bar only outputs its address's details.
     */
    useEffect(() => {
        if (data.addresses.status === "success"){
            var locations = [];
            // Combined addresses on UNION
            if (data.data[0].formattedAddress.substr(0,4) === "1952" && data.data[0].formattedAddress.includes("Union")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "1952" || item.address.substr(0,4) === "1954" || item.address.substr(0,4) === "1956");
            } else if((data.data[0].formattedAddress.substr(0,4) === "1954" || data.data[0].formattedAddress.substr(0,4) === "1956") && data.data[0].formattedAddress.includes("Union")){
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,4) === "2031" && data.data[0].formattedAddress.includes("Union")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "2031" || item.address.substr(0,4) === "2033");
            } else if (data.data[0].formattedAddress.substr(0,4) === "2033" && data.data[0].formattedAddress.includes("Union")) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,4) === "2277" && data.data[0].formattedAddress.includes("Union")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "2277" || item.address.substr(0,4) === "2285" || item.address.substr(0,4) === "2299");
            } else if ((data.data[0].formattedAddress.substr(0,4) === "2285" || data.data[0].formattedAddress.substr(0,4) === "2299") && data.data[0].formattedAddress.includes("Union")) {
                locations = [];
            } 
            
            // Combined addresses on HAIGHT
             else if (data.data[0].formattedAddress.substr(0,4) === "1601" && data.data[0].formattedAddress.includes("Haight")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "1601" || item.address.substr(0,4) === "1603" || item.address.substr(0,4) === "1605" || item.address.substr(0,4) === "1607");
            } else if ((data.data[0].formattedAddress.substr(0,4) === "1603" || data.data[0].formattedAddress.substr(0,4) === "1605" || data.data[0].formattedAddress.substr(0,4) === "1607") && data.data[0].formattedAddress.includes("Haight")) {
                locations = [];
            } 
            
            // Combined addresses on VALENCIA
            else if (data.data[0].formattedAddress.substr(0,3) === "539" && data.data[0].formattedAddress.includes("Valencia")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "539" || item.address.substr(0,3) === "535");
            } else if (data.data[0].formattedAddress.substr(0,3) === "535" && data.data[0].formattedAddress.includes("Valencia")) {
                locations = [];
            }

            // Combined addresses on POST
            else if (data.data[0].formattedAddress.substr(0,4) === "1600" && data.data[0].formattedAddress.includes("Post")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "1600" || item.address.substr(0,4) === "1604" || item.address.substr(0,4) === "1610");
            } else if ((data.data[0].formattedAddress.substr(0,4) === "1604" || data.data[0].formattedAddress.substr(0,4) === "1610") && data.data[0].formattedAddress.includes("Post")) {
                locations = [];
            }else if (data.data[0].formattedAddress.substr(0,3) === "726" && data.data[0].formattedAddress.includes("Post")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "726" || item.address.substr(0,3) === "728");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "728") && data.data[0].formattedAddress.includes("Post")) {
                locations = [];
            }

            // Combined addresses on CASTRO
            else if (data.data[0].formattedAddress.substr(0,3) === "570" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "570" || item.address.substr(0,3) === "566");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "566" && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,3) === "556" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "556" || item.address.substr(0,3) === "554");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "554" && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,3) === "552" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "552" || item.address.substr(0,3) === "550" || item.address.substr(0,3) === "548");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "550" || data.data[0].formattedAddress.substr(0,3) === "548"  && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,3) === "516" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "516" || item.address.substr(0,3) === "518");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "518" && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,3) === "495" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "495" || item.address.substr(0,3) === "491" || item.address.substr(0,3) === "489");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "491" || data.data[0].formattedAddress.substr(0,3) === "489" && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            } else if (data.data[0].formattedAddress.substr(0,3) === "440" && data.data[0].formattedAddress.includes("Castro")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,3) === "440" || item.address.substr(0,3) === "438" || item.address.substr(0,3) === "434");
            } else if ((data.data[0].formattedAddress.substr(0,3) === "438" || data.data[0].formattedAddress.substr(0,3) === "434" && data.data[0].formattedAddress.includes("Castro"))) {
                locations = [];
            }  

            // Combined addresses on Irving
            else if (data.data[0].formattedAddress.substr(0,4) === "2201" && data.data[0].formattedAddress.includes("Irving")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "2201" || item.address.substr(0,4) === "2203");
            } else if ((data.data[0].formattedAddress.substr(0,4) === "2203") && data.data[0].formattedAddress.includes("Irving")) {
                locations = [];
            }

            // Combined addresses on W Portal Ave
            else if (data.data[0].formattedAddress.substr(0,2) === "60" && data.data[0].formattedAddress.includes("W Portal Ave")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,2) === "60" || item.address.substr(0,2) === "62");
            } else if ((data.data[0].formattedAddress.substr(0,2) === "62") && data.data[0].formattedAddress.includes("W Portal Ave")) {
                locations = [];
            }

            // Combined addresses on Market St
            else if (data.data[0].formattedAddress.substr(0,4) === "1857" && data.data[0].formattedAddress.includes("Market St")) {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === "1857" || item.address.substr(0,4) === "1855" || item.address.substr(0,4) === "1853");
            } else if ((data.data[0].formattedAddress.substr(0,4) === "1855" || data.data[0].formattedAddress.substr(0,4) === "1853") && data.data[0].formattedAddress.includes("Market St")) {
                locations = [];
            }

            else {
                locations = data.addresses.data?.addresses.filter(item => item.address.substr(0,4) === data.data[0].formattedAddress.substr(0,4));
            }

            // Make sure numbers are sorted correctly
            const extractNumber = (address) => {
                const match = address.match(/^\d+/);
                return match ? parseInt(match[0]) : 0;
            };
            // console.log(locations);
            if(flipped){
                locations.sort((a, b) => extractNumber(b.address) - extractNumber(a.address));
            } else {
                locations.sort((a, b) => extractNumber(a.address) - extractNumber(b.address));
            }
            
            setMessage(locations);
        }
    }, [data.addresses.data, data.data]);

    /**
     * This function handles opening the location's details modal
     * @param { Boolean }   modalOpen Determines whether the modal is open
     * @param { Event }     e      The event
     * @param { ObjectID }  id     The id of the clicked location
     */
    const handleOpen = (e, id) => {
        e.stopPropagation();
        setTheID(id);
        setModalOpen(true);
        document.body.style.overflow = 'hidden';
    };


    /**
     * This function handles the search function
     */
    useEffect(() => {
        setFilteredLocations(data.locs);

        let firstFilteredLocation;
        if (filteredLocations && filteredLocations.length > 0) {
            firstFilteredLocation = filteredLocations[0];
        }
        if (!firstFilteredLocation) return;

        // Find the first matching location from the message
        const matchingMessage = message.find(msg => {
            // Check for exact match by business name if there is only one filtered location
            if (filteredLocations.length === 1 &&
                msg.businessName.toLowerCase() === firstFilteredLocation.name.toLowerCase() && msg.address.substr(0, 4) === firstFilteredLocation.address.substr(0, 4)) {
                return true;
            } 
            // Check for matching address prefix if there are fewer than 10 filtered locations
            else if (filteredLocations.length > 1 && filteredLocations.length < 10 && firstFilteredLocation.name.includes("Space Available")) {
                return msg.address.substr(0, 4) === firstFilteredLocation.address.substr(0, 4);
            }
            // Check for matching address prefix if there are fewer than 10 filtered locations
            else if (filteredLocations.length > 1 && filteredLocations.length < 10 &&
                msg.businessName.toLowerCase() === firstFilteredLocation.name.toLowerCase() && msg.address.substr(0, 4) === firstFilteredLocation.address.substr(0, 4)) {
                return msg.address.substr(0, 4) === firstFilteredLocation.address.substr(0, 4);
            }
            return false;
        });

        if (matchingMessage && ref.current && searchClicked) {
            promiseResolver(firstFilteredLocation, ref);
        }
        if (!searchClicked) {
            setTheID(null);
        }
    }, [data.locs, ref.current, searchClicked]);

    // Resolve all of the actions one by one to make sure the screen scrolls down before showing the shadow
    async function promiseResolver(firstFilteredLocation, ref){
        const promise1 = new Promise((resolve, reject) =>{
            setTheID(firstFilteredLocation.id);
            resolve();
        });
        const promise2 = promise1.then(
            setTimeout(() => {
                // Force reflow
                const reflow = ref.current.offsetHeight;
                ref.current.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }, 100)); // Delay is 100ms 
        const promise3 = promise2.then(setUpClicked(false));
        const promise4 = promise3.then(() => {
            document.body.style.overflow = 'hidden'
        });
        await promise4;
    }

    /**  HANDLES SETTING THE USER DATA  **/
    useEffect(() => {
        if(userData){
            setAccountData(userData);
        } 
    }, [userData, modalChange]);

    if (message.length > 0) {
        return (
            <LocationBarContainer>
                {message.map(((item) => {
                    // Get the Business Name
                    var businessName = item.businessName;

                    // Get the Building Number
                    var buildingNum = "";
                    for (var i = 0; i < item.address.length; i++) {
                        if (item.address[i] !== " ") {
                            buildingNum += item.address[i];
                        } else {
                            break;
                        }
                    }

                    // Check Availability
                    var availability = item.status;
                    var available = "available";
                    if (availability === "Unavailable") {
                        available = "unavailable";
                    } else if (availability === "Temporarily Closed") {
                        available = "tempclosed";
                    } else if (availability === "Available") {
                        available = "available";
                    } else {
                        available = null;
                    }

                    const id = item._id;

                    return (
                        <div
                            key={id}>
                                {!upClicked && !highlightClicked && id === theID ? 
                                <>
                                <OutsideShadow onClick={() => {
                                    setSearchClicked(false)
                                    document.body.style.overflow = 'unset'
                                    setTheID(null)
                                    setHighlightClicked(true)
                                }}>
                                </OutsideShadow>
                                <Shadow />
                                </> : <></>}
                            <LocRow
                                onClick={(e) => handleOpen(e, id)}
                                style={{ zIndex: searchClicked && id === theID ? 101 : 0}}
                                ref={ref}>
                                <LocColName>
                                    <div style={{display: "inline-block",
                                                  verticalAlign: "middle",
                                                  lineHeight: "normal",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis"}}>
                                                    {businessName}
                                    </div>
                                </LocColName>
                                { item.notes !== "" ? (
                                    <LocColPlus><img src={circle_plus} alt="circle_plus"></img></LocColPlus>
                                ) : (
                                    <></>
                                )}
                                <LocColBuildingNum>{buildingNum}</LocColBuildingNum>
                                {available ? (
                                    available === "available" ? (
                                        <LocColAvailability>
                                            <AvailableBar1></AvailableBar1>
                                        </LocColAvailability>
                                    ) : (
                                        ( available === "unavailable" ) ? (
                                            <LocColAvailability>
                                                <NotAvailableBar1></NotAvailableBar1>
                                            </LocColAvailability>
                                        ) : (
                                            ( available === "tempclosed" ) ? (
                                                <LocColAvailability>
                                                    <TemporarilyClosedBar></TemporarilyClosedBar>
                                                </LocColAvailability>
                                            ) : (
                                                <></>
                                            )
                                        )
                                    )
                                ) : ( available === null ? (
                                    <LocCol></LocCol>
                                    ) : (
                                        <></>
                                    )
                                )}
                            </LocRow>
                            {theID && modalOpen && <Modal 
                                                    props={item} 
                                                    id={id} 
                                                    theID={theID}
                                                    setTheID={setTheID} 
                                                    setSearchClicked={setSearchClicked}
                                                    setModalOpen={setModalOpen}
                                                    modalOpen={modalOpen}
                                                    modalChange={modalChange}
                                                    setModalChange={setModalChange}
                                                    setAccountData={setAccountData}
                                                    onUpdate={onUpdate} />}
                        </div>
                    )
                
                }))}
            </LocationBarContainer>
        )
    }
};

export default LocationBar;
